import Vue from 'vue'
import Vuex from 'vuex'
import grades from './modules/grades.store'
import auth from './modules/auth.store'
import account from './modules/account.store'
import importMarks from './modules/import-marks.store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    grades,
    auth,
    importMarks,
    account
  },
  strict: debug
})
